import React, { memo, forwardRef } from "react";
const SvgPi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11.872 20.224v-8.496h-.768c-.416 0-.704-.104-.864-.312a1.081 1.081 0 01-.24-.672c0-.224.08-.44.24-.648.16-.208.448-.312.864-.312h10.464c.4 0 .68.104.84.312.16.208.24.424.24.648 0 .24-.08.464-.24.672-.16.208-.44.312-.84.312h-.984v6.48c0 .416.04.72.12.912.096.192.28.288.552.288.096 0 .208-.016.336-.048.128-.032.232-.048.312-.048.544 0 .816.28.816.84 0 .32-.168.584-.504.792-.432.256-.928.384-1.488.384-.864 0-1.448-.256-1.752-.768-.304-.528-.456-1.264-.456-2.208v-6.624h-4.584v8.496c0 .416-.112.712-.336.888-.208.16-.44.24-.696.24-.144 0-.288-.024-.432-.072-.144-.048-.28-.16-.408-.336-.128-.192-.192-.432-.192-.72z"
      />
    </svg>
  );
});
SvgPi.displayName = "SvgPi";
const MemoForwardRef = memo(SvgPi);
export default MemoForwardRef;
